import { CatalogForm } from './catalog-form';
import { ExternalItemForm } from './external-item-form';
import { ExternalItemType } from './external-item-type';
import { ItemSource } from './item-source';
import { ResourceType } from './resource-type';
import { SelectPolicy } from './select-policy';
import { RefundRequestWizardStepIds } from './step-ids';
import { Summary } from './summary';

export { RefundRequestWizardStepIds } from './step-ids';

export const steps = {
  [RefundRequestWizardStepIds.ResourceType]: { component: ResourceType },
  [RefundRequestWizardStepIds.SelectPolicy]: { component: SelectPolicy },
  [RefundRequestWizardStepIds.ItemSource]: { component: ItemSource },
  [RefundRequestWizardStepIds.CatalogForm]: { component: CatalogForm },
  [RefundRequestWizardStepIds.ExternalResourceType]: {
    component: ExternalItemType,
  },
  [RefundRequestWizardStepIds.ExternalItemForm]: {
    component: ExternalItemForm,
  },
  [RefundRequestWizardStepIds.Summary]: { component: Summary },
};
